import { render, staticRenderFns } from "./ArticleTwo.vue?vue&type=template&id=637c1556&scoped=true"
import script from "./ArticleTwo.vue?vue&type=script&lang=js"
export * from "./ArticleTwo.vue?vue&type=script&lang=js"
import style0 from "./ArticleTwo.vue?vue&type=style&index=0&id=637c1556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c1556",
  null
  
)

export default component.exports